import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceViewServiceRecordView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceViewServiceRecordView, _super);
    function DeviceViewServiceRecordView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.runtime = 0; //TODO
        _this.lastRuntime = null;
        _this.serviceValues = null;
        _this.serviceMessage = "";
        return _this;
    }
    DeviceViewServiceRecordView.prototype.mounted = function () {
        this.serviceMessage = this.$t("deviceViewServiceRecordView.searching").toString();
        this.getLastRuntime();
    };
    DeviceViewServiceRecordView.prototype.getServiceData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ServiceValues;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("devicesensorlog/servicedata", { params: { serialNumber: this.device.serial, runtime: this.runtime } })];
                    case 1:
                        ServiceValues = (_a.sent()).data;
                        this.serviceValues = ServiceValues;
                        if (!this.serviceValues)
                            this.serviceMessage = this.$t("deviceViewServiceRecordView.noData").toString();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceViewServiceRecordView.prototype.getLastRuntime = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("devicesensorlog/runtime", { params: { serialNumber: this.device.serial } })];
                    case 1:
                        _a.lastRuntime = (_b.sent()).data;
                        this.runtime = this.lastRuntime.runtime;
                        if (this.runtime > 0)
                            this.lastRuntime.runtimeDateString = "(" + new Date(this.lastRuntime.runtimeDateString).toLocaleDateString().split('T')[0] + ")";
                        this.getServiceData();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceViewServiceRecordView.prototype, "device", void 0);
    DeviceViewServiceRecordView = tslib_1.__decorate([
        Component
    ], DeviceViewServiceRecordView);
    return DeviceViewServiceRecordView;
}(Vue));
export default DeviceViewServiceRecordView;
